import request from './request';

export function getCategory() {
  return request.get(`${process.env.VUE_APP_API_APIBASEURL}document/getApiDocumentCategoryList`);
}

export function submitDocumentForm(params) {
  return request.post(`${process.env.VUE_APP_API_APIBASEURL}/requirement/create`, params);
}

export function getDocumentById(params) {
  return request.get(`${process.env.VUE_APP_API_APIBASEURL}/document/getApiDocument?apiId=${params}`);
}
